var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _vm._m(0),
      _c("div", { staticClass: "ai-stats-grid" }, [
        _c("div", { staticClass: "stat-card blue" }, [
          _vm._m(1),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Tổng người dùng AI (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(
                _vm._s(_vm.dataTable.length) + " / " + _vm._s(_vm.totalElements)
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card green" }, [
          _vm._m(2),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Tổng số thẻ (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.totalCards)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card purple" }, [
          _vm._m(3),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Tổng số vân tay (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.totalFingers)),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "glass-card mb-4" },
        [
          _c(
            "el-form",
            {
              staticClass: "modern-filter-form",
              attrs: { inline: true, model: _vm.dataFilter },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Trường học" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Tất cả các trường",
                      },
                      on: { change: _vm.handleSchoolChange },
                      model: {
                        value: _vm.dataFilter.idSchool,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataFilter, "idSchool", $$v)
                        },
                        expression: "dataFilter.idSchool",
                      },
                    },
                    _vm._l(_vm.schoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Thiết bị" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: _vm.dataFilter.idSchool
                          ? "Tất cả thiết bị"
                          : "Chọn trường trước",
                        disabled: !_vm.dataFilter.idSchool,
                      },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.dataFilter.idDevice,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataFilter, "idDevice", $$v)
                        },
                        expression: "dataFilter.idDevice",
                      },
                    },
                    _vm._l(_vm.deviceList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.nameDevice },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Loại tài khoản" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: { clearable: "", placeholder: "Tất cả loại" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.dataFilter.typeAccount,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataFilter, "typeAccount", $$v)
                        },
                        expression: "dataFilter.typeAccount",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Giáo viên", value: "teacher" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Học sinh", value: "parent" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tìm kiếm nhanh" } },
                [
                  _c("el-input", {
                    staticClass: "modern-input",
                    attrs: {
                      clearable: "",
                      placeholder: "Tên, Employee No, User ID...",
                      "prefix-icon": "el-icon-search",
                    },
                    on: { clear: _vm.handleSearch },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.dataFilter.query,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataFilter, "query", $$v)
                      },
                      expression: "dataFilter.query",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("Tìm kiếm")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.resetFilters },
                    },
                    [_vm._v("Làm mới")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "modern-table",
              attrs: {
                data: _vm.dataTable,
                "element-loading-text": "Đang quét thông tin nhận diện AI...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.calculateStt,
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Tên trường", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "school-name-text" }, [
                          _vm._v(_vm._s(row.schoolName || "—")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Thông tin nhân sự", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "user-profile-cell" },
                          [
                            _c(
                              "el-image",
                              {
                                staticClass: "user-avatar",
                                attrs: { src: row.urlWebFace, fit: "cover" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "img-error-placeholder",
                                    attrs: { slot: "error" },
                                    slot: "error",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-user-solid",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "user-details" },
                              [
                                _c("span", { staticClass: "user-name" }, [
                                  _vm._v(_vm._s(row.name)),
                                ]),
                                _c(
                                  "el-tag",
                                  {
                                    staticClass: "user-tag",
                                    attrs: {
                                      type: _vm.getAccountTagType(
                                        row.typeAccount
                                      ),
                                      size: "mini",
                                      effect: "dark",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getAccountLabel(row.typeAccount)
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Mã đối chiếu", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticClass: "info-list" }, [
                          _c("div", [
                            _c("span", { staticClass: "info-lbl" }, [
                              _vm._v("ID Onekids:"),
                            ]),
                            _c("strong", [_vm._v(_vm._s(row.idUser))]),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "info-lbl" }, [
                              _vm._v("ID Thiết bị:"),
                            ]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  row.deviceRecognition
                                    ? row.deviceRecognition.id
                                    : "—"
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "info-lbl" }, [
                              _vm._v("Mã NV:"),
                            ]),
                            _c("strong", [
                              _vm._v(_vm._s(row.employeeNo || "—")),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Tên thiết bị", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "device-name-text" }, [
                          _c("i", {
                            staticClass: "el-icon-s-platform",
                            staticStyle: {
                              color: "#64748b",
                              "margin-right": "4px",
                            },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                row.deviceRecognition
                                  ? row.deviceRecognition.name
                                  : "—"
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Phương thức nhận diện",
                  width: "180",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticClass: "credentials-badges" }, [
                          _c(
                            "span",
                            {
                              staticClass: "badge-item",
                              class: { active: row.urlWebFace },
                            },
                            [
                              _c("i", { staticClass: "el-icon-picture" }),
                              _vm._v(" Face\n            "),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "badge-item",
                              class: {
                                active:
                                  row.cardRecognitionList &&
                                  row.cardRecognitionList.length > 0,
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-bank-card" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.cardRecognitionList
                                      ? row.cardRecognitionList.length
                                      : 0
                                  ) +
                                  " Card\n            "
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "badge-item",
                              class: {
                                active:
                                  row.fingerRecognitionList &&
                                  row.fingerRecognitionList.length > 0,
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-thumb" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.fingerRecognitionList
                                      ? row.fingerRecognitionList.length
                                      : 0
                                  ) +
                                  " Finger\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  width: "100",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-view",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleShowDetail(row)
                              },
                            },
                          },
                          [_vm._v("\n            Chi tiết\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper mt-3 flex justify-center" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageIndex,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.size,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalElements,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    _vm.pageIndex = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.pageIndex = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "Chi tiết thông tin nhận diện AI",
            visible: _vm.drawerVisible,
            size: "50%",
            "custom-class": "modern-drawer",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _vm.selectedUser
            ? _c(
                "div",
                { staticClass: "drawer-content" },
                [
                  _c("div", { staticClass: "drawer-profile-header" }, [
                    _c(
                      "div",
                      { staticClass: "profile-card" },
                      [
                        _c(
                          "el-image",
                          {
                            staticClass: "large-avatar",
                            attrs: {
                              src: _vm.selectedUser.urlWebFace,
                              fit: "cover",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "img-error-placeholder-large",
                                attrs: { slot: "error" },
                                slot: "error",
                              },
                              [_c("i", { staticClass: "el-icon-user-solid" })]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "profile-meta" }, [
                          _c("h2", [_vm._v(_vm._s(_vm.selectedUser.name))]),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2 mt-1" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getAccountTagType(
                                      _vm.selectedUser.typeAccount
                                    ),
                                    size: "medium",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getAccountLabel(
                                          _vm.selectedUser.typeAccount
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm.selectedUser.administrator
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "medium",
                                        effect: "light",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Administrator\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-tabs",
                    {
                      staticClass: "modern-tabs mt-4",
                      attrs: { type: "border-card" },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "Dữ liệu hình ảnh" } },
                        [
                          _c("div", { staticClass: "single-image-gallery" }, [
                            _c("div", { staticClass: "single-image-box" }, [
                              _c("p", { staticClass: "img-title" }, [
                                _vm._v("Ảnh nhận diện"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "img-preview-container-large" },
                                [
                                  _c(
                                    "el-image",
                                    {
                                      staticClass: "preview-img-large",
                                      attrs: {
                                        src: _vm.selectedUser.urlWebFace,
                                        fit: "contain",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "img-placeholder",
                                          attrs: { slot: "placeholder" },
                                          slot: "placeholder",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-loading",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "img-placeholder",
                                          attrs: { slot: "error" },
                                          slot: "error",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-picture-outline",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "url-copy-box" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "medium",
                                      readonly: "",
                                      value: _vm.selectedUser.urlWebFace,
                                      placeholder: "Chưa có URL",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append",
                                          fn: function () {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    icon: "el-icon-document-copy",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyText(
                                                        _vm.selectedUser
                                                          .urlWebFace
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Sao chép")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1315142348
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "Dữ liệu thẻ & Vân tay" } },
                        [
                          _c("div", { staticClass: "credentials-info mt-2" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("i", { staticClass: "el-icon-bank-card" }),
                              _vm._v(" Danh sách thẻ nhận diện"),
                            ]),
                            _c("div", { staticClass: "card-list mt-2" }, [
                              !_vm.selectedUser.cardRecognitionList ||
                              _vm.selectedUser.cardRecognitionList.length === 0
                                ? _c("div", { staticClass: "no-data-alert" }, [
                                    _vm._v(
                                      "\n                Không tìm thấy thẻ nào được đăng ký cho người dùng này.\n              "
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "card-items" },
                                    _vm._l(
                                      _vm.selectedUser.cardRecognitionList,
                                      function (card, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "card-item-tag",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-bank-card",
                                            }),
                                            _c("span", [
                                              _vm._v("Số thẻ: "),
                                              _c("strong", [
                                                _vm._v(_vm._s(card.cardNumber)),
                                              ]),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                            ]),
                            _c("div", { staticClass: "section-title mt-4" }, [
                              _c("i", { staticClass: "el-icon-thumb" }),
                              _vm._v(" Danh sách mẫu vân tay"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "fingerprint-list mt-2" },
                              [
                                !_vm.selectedUser.fingerRecognitionList ||
                                _vm.selectedUser.fingerRecognitionList
                                  .length === 0
                                  ? _c(
                                      "div",
                                      { staticClass: "no-data-alert" },
                                      [
                                        _vm._v(
                                          "\n                Không tìm thấy mẫu vân tay nào được đăng ký cho người dùng này.\n              "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "finger-items" },
                                      _vm._l(
                                        _vm.selectedUser.fingerRecognitionList,
                                        function (finger, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "finger-item-tag",
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-thumb",
                                              }),
                                              _c("span", [
                                                _vm._v("Vị trí ngón: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    "#" +
                                                      _vm._s(finger.fingerIndex)
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "Thiết bị liên kết" } },
                        [
                          _c("div", { staticClass: "device-time-info mt-2" }, [
                            _c("div", { staticClass: "section-title" }, [
                              _c("i", { staticClass: "el-icon-mobile-phone" }),
                              _vm._v(" Thiết bị nhận diện được gán"),
                            ]),
                            _vm.selectedUser.deviceRecognition
                              ? _c(
                                  "div",
                                  { staticClass: "device-card-large mt-3" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "device-header" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "device-icon-large" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-s-platform",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "h3",
                                          { staticClass: "device-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedUser
                                                  .deviceRecognition.name
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "device-details-grid" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "grid-item" },
                                          [
                                            _c("span", { staticClass: "lbl" }, [
                                              _vm._v("Tên miền (Domain)"),
                                            ]),
                                            _c(
                                              "strong",
                                              { staticClass: "val" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedUser
                                                      .deviceRecognition
                                                      .domain || "—"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "grid-item" },
                                          [
                                            _c("span", { staticClass: "lbl" }, [
                                              _vm._v("Địa chỉ IP"),
                                            ]),
                                            _c(
                                              "strong",
                                              { staticClass: "val" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedUser
                                                      .deviceRecognition.ip ||
                                                      "—"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "grid-item" },
                                          [
                                            _c("span", { staticClass: "lbl" }, [
                                              _vm._v(
                                                "Cổng cục bộ (Port Local)"
                                              ),
                                            ]),
                                            _c(
                                              "strong",
                                              { staticClass: "val" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedUser
                                                      .deviceRecognition
                                                      .portLocal || "—"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "grid-item" },
                                          [
                                            _c("span", { staticClass: "lbl" }, [
                                              _vm._v("Tài khoản thiết bị"),
                                            ]),
                                            _c(
                                              "strong",
                                              { staticClass: "val" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedUser
                                                      .deviceRecognition
                                                      .username || "—"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "grid-item full-width",
                                          },
                                          [
                                            _c("span", { staticClass: "lbl" }, [
                                              _vm._v("Mật khẩu thiết bị"),
                                            ]),
                                            _c(
                                              "strong",
                                              { staticClass: "val code-font" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedUser
                                                      .deviceRecognition
                                                      .password || "—"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "no-data-alert mt-2" },
                                  [
                                    _vm._v(
                                      "\n              Chưa gán thiết bị nhận diện nào.\n            "
                                    ),
                                  ]
                                ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ai-header-banner" }, [
      _c("div", { staticClass: "banner-overlay" }),
      _c("div", { staticClass: "banner-content" }, [
        _c("div", { staticClass: "banner-left" }, [
          _c("div", { staticClass: "ai-icon-pulse" }, [
            _c("i", { staticClass: "el-icon-cpu" }),
          ]),
          _c("div", [
            _c("h1", { staticClass: "banner-title" }, [
              _vm._v("HỆ THỐNG KIỂM TRA THÔNG TIN NHẬN DIỆN AI"),
            ]),
            _c("p", { staticClass: "banner-subtitle" }, [
              _vm._v(
                "Truy vấn, đối soát dữ liệu khuôn mặt, vân tay và thẻ trên các thiết bị nhận diện AI toàn hệ thống."
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-user-solid" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-bank-card" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-thumb" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }